module.exports = __webpack_public_path__ + "img/estetoscopio.910a4cd2.png";